/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Required_TextInputs */



/**
* | output |
* | --- |
* | "Please re-import the media file." |
*
* @param {Load_Project_File_Media_Import_Required_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_required_text = /** @type {((inputs?: Load_Project_File_Media_Import_Required_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Required_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez reimporter le fichier media.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte importieren Sie die Mediendatei erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimportare il file multimediale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, повторно импортируйте медиафайл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, vuelva a importar el archivo multimedia.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请重新导入媒体文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルを再度インポートしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया मीडिया फ़ाइल को पुनः आयात करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, importe o arquivo de mídia novamente.")
	return /** @type {LocalizedString} */ ("Please re-import the media file.")
});